import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: '',
    section: {
        ids: [],
        entries: {}
    },
    column: {},
    component: {}
}

export const footerSlice = createSlice({
  name: 'footer',
  initialState,
  reducers: {
      updateFooterState: (state, action) => {
        Object.assign(state, {
            section: action.payload.section,
            column: action.payload.column,
            component: action.payload.component,
            name: action.payload.name
        })
      }
  },
})

// Action creators are generated for each case reducer function
export const { updateFooterState } = footerSlice.actions

export default footerSlice.reducer